<h1 class="title">
  @if (icon) {
    <fa-icon class="title-icon" [icon]="icon"></fa-icon>
  }
  <div class="title-text">{{ title }}</div>
  @if (hasClose) {
    <button
      class="close-btn"
      [class.fancy]="fancyClose"
      (click)="onClose()"
      >
      <fa-icon class="close-icon" [icon]="['fas', 'times']"></fa-icon>
      <div class="mat-ripple-receiver" matRipple></div>
    </button>
  }
</h1>
